import { createFileRoute, redirect } from "@tanstack/react-router";
import { loadBlogList } from "~/utils/content-fns";
import { seo, seoLinks } from "~/utils/seo";
import { Pagination } from "~/components/Pagination";
import { BlogCard, type BlogCardData } from "~/components/BlogCard";

export const Route = createFileRoute("/blog/page/$page")({
  loader: async ({ params }) => {
    const pageNum = parseInt(params.page, 10);
    if (isNaN(pageNum) || pageNum < 1) throw redirect({ to: "/blog" });
    if (pageNum === 1) throw redirect({ to: "/blog" });

    const result = await loadBlogList({ data: { page: pageNum } });

    if (pageNum > result.totalPages) throw redirect({ to: "/blog" });

    return result;
  },
  head: ({ loaderData }) => ({
    meta: loaderData
      ? seo({
          title: `Blog - Page ${loaderData.page}`,
          description:
            "Insights on identity security, access governance, and modern IGA from the C1 team.",
          url: `/blog/page/${loaderData.page}/`,
        })
      : [],
    links: loaderData ? seoLinks({ url: `/blog/page/${loaderData.page}/` }) : [],
  }),
  component: BlogPage,
});

function BlogPage() {
  const { posts, page, totalPages } = Route.useLoaderData();

  return (
    <div className="mx-auto max-w-screen-xl px-4 py-16 md:px-8">
      <h1 className="mb-2 font-display text-4xl font-bold text-charcoal">Blog</h1>
      <p className="mb-12 font-body text-lg text-gray-60">
        Insights on identity security, access governance, and modern IGA.
      </p>

      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {posts.map((post) => (
          <BlogCard key={post.slug} post={post} />
        ))}
      </div>

      <Pagination currentPage={page} totalPages={totalPages} basePath="/blog" />
    </div>
  );
}
